export default {
  'onlineOrderingSettings.title': '餐厅网站',
  'onlineOrderingSettings.tabs.general': '基本',
  'onlineOrderingSettings.tabs.display': '显示',
  'onlineOrderingSettings.tabs.feeAndTips': '费用 & 小费',

  'onlineOrderingSettings.section.banner': '横幅',
  'onlineOrderingSettings.section.notice': '注意事项',
  'onlineOrderingSettings.section.layout': '布局',
  'onlineOrderingSettings.section.top.banner.title': '线上订餐体验再次升级⎯免抽成，为您带来更多盈利！',
  'onlineOrderingSettings.section.top.banner.content':
    '提高您店铺的线上曝光率，让顾客通过谷歌搜索和谷歌地图可直接在您的网站下单。无需支付高额外卖平台抽成费用，为您保留更多的利润空间。',
  'onlineOrderingSettings.section.top.banner.preview': '预览餐厅网站',
  'onlineOrderingSettings.section.onlineOrderHours': '网站订单时间',
  'onlineOrderingSettings.section.businessHour': '营业时间',
  'onlineOrderingSettings.section.specialTime': '特殊/假日营业时间',
  'onlineOrderingSettings.section.specialTime.timeOverlapDetailed':
    '时间段 {current} 与已存在的时间段 {overlapping} 重叠',
  'onlineOrderingSettings.section.menuHour': '点餐时间',
  'onlineOrderingSettings.section.preparation': '备餐设置',
  'onlineOrderingSettings.section.autoConfirmOrders': '自动确认订单并送厨',
  'onlineOrderingSettings.section.scheduledOrder': '预订单',
  'onlineOrderingSettings.section.fee': '费用',
  'onlineOrderingSettings.section.tips': '小费',
  'onlineOrderingSettings.fee.new_fee': '新建费用',
  'onlineOrderingSettings.fee.validation.value_must_greater_than_zero': '金额必须大于0',
  'onlineOrderingSettings.fee.self_delivery': '递送费',
  'onlineOrderingSettings.fee.self_delivery_minimum_order': '起送金额门槛设置',
  'onlineOrderingSettings.fee.self_delivery_minimum_order_tooltip':
    '若启用该设置，当订单小计未达起送金额时，顾客将无法继续完成交易。',
  'onlineOrderingSettings.fee.self_delivery_no_minimum_order_value': '无起送金额',
  'onlineOrderingSettings.fee.self_delivery_minimum_order_value': '起送金额为',
  'onlineOrderingSettings.fee.self_delivery_free_delivery': '免费送餐门槛设置',
  'onlineOrderingSettings.fee.self_delivery_free_delivery_tooltip':
    '若启用该设置，当订单小计超过预设金额时，店铺将提供免费送餐服务。',
  'onlineOrderingSettings.fee.self_delivery_free_delivery_no_free': '不提供免费送餐服务',
  'onlineOrderingSettings.fee.self_delivery_free_delivery_free_value': '满 ${thresholdValue} 可享受免费送餐',
  'onlineOrderingSettings.fee.self_delivery_free_delivery_free_and_minimum_valid':
    '若配置上放起送金额，则此金额必须超过起送金额',
  'onlineOrderingSettings.fee.table.action': '操作',
  'onlineOrderingSettings.fee.table.no': '否',
  'onlineOrderingSettings.fee.table.yes': '是',
  'onlineOrderingSettings.fee.table.delivery.tip': '在创建Online递送订单时可以快速添加这个费用',

  'onlineOrderingSettings.section.preparation.prepareTime': '备餐时间',
  'onlineOrderingSettings.section.preparation.prepareTime.content':
    '网站订单的备餐时长。该时间也用于预估顾客下单时提供的预计送达或自取的时间。',
  'onlineOrderingSettings.section.preparation.order_acceptance_mode': '接单模式',
  'onlineOrderingSettings.section.preparation.order_acceptance_mode.content':
    '网站订单可以自动或手动接单，需进入“送厨设置页面“相应设置。',
  'onlineOrderingSettings.section.preparation.send_setting_section': '送厨设置页面',
  'onlineOrderingSettings.section.preparation.schedulingSettings': '最大预约天数',
  'onlineOrderingSettings.section.preparation.schedulingSettings.content': '顾客可以提前下预定单的最大天数。',
  'onlineOrderingSettings.section.notice.titleEN': '标题',
  'onlineOrderingSettings.section.notice.contentEN': '内容',
  'onlineOrderingSettings.section.notice.titleZH': '中文标题',
  'onlineOrderingSettings.section.notice.contentZH': '中文内容',
  'onlineOrderingSettings.section.layout.pc': '电脑端布局',
  'onlineOrderingSettings.section.layout.mobile': '手机端布局',
  'onlineOrderingSettings.section.layout.recommend': '（推荐）',
  'onlineOrderingSettings.section.layout.image_left': '图在左侧',
  'onlineOrderingSettings.section.layout.image_right': '图在右侧',
  'onlineOrderingSettings.section.layout.image_top': '图在顶部',
  'onlineOrderingSettings.section.specialTime.allDaysClose': '全天关闭',
  'onlineOrderingSettings.section.menuHour.guide': '餐厅网站的菜单点餐时间设置，请前往',
  'onlineOrderingSettings.section.autoConfirmOrders.guide': '关于餐厅网站自动接单的设置，请前往',
  'onlineOrderingSettings.section.fee.guide': '关于餐厅网站其他费用的设置，请前往',
  'onlineOrderingSettings.section.tips.guide': '关于餐厅网站小费的设置，请前往',
  'onlineOrderingSettings.section.tips.guide.takeOut':
    '对来自POS, 扫码点餐，自助点餐机和电话点餐的外带订单生效，关于餐厅网站小费的设置，请前往',
  'onlineOrderingSettings.section.tips.guide.delivery': '对电话订餐的递送订单生效，关于餐厅网站小费的设置，请前往',
  'onlineOrderingSettings.inputLimit': '(最多{maxCount}个字符)',
  'onlineOrderingSettings.customTipMaxAmount': '自定义小费最高金额',

  'onlineOrderingSettings.action.addTime': '添加时间',
  'onlineOrderingSettings.action.uploadBanner': '上传横幅',
  'onlineOrderingSettings.bannerUploadGuide':
    '推荐上传图片尺寸为1312 x 196 px, 上传图片格式为JPG, JPEG; 大小为5M以内的.',
  'onlineOrderingSettings.cropBanner': '裁剪横幅',

  'onlineOrderingSettings.low': '低',
  'onlineOrderingSettings.medium': '中',
  'onlineOrderingSettings.high': '高',
  'onlineOrderingSettings.default': '默认值',
  'onlineOrderingSettings.enable_dish_level_notes': '允许添加订单备注',
  'onlineOrderingSettings.enable_zh_under_en': '在英文界面显示菜品中文信息',
  'onlineOrderingSettings.enable_zh_under_en.tips': '开启后若顾客选择英文，餐厅网站的菜单会同时显示中英双语',
  'onlineOrderingSettings.need_utensil': '启用"需要餐具"选项',
  'onlineOrderingSettings.display_soldout': '显示售罄菜品和二级选项',
  'onlineOrderingSettings.options': '自定义设置',
  'onlineOrderingSettings.options.content': '您可以根据您的需要自定义下列设置，提升顾客的线上订餐体验并简化流程。',
  'onlineOrderingSettings.pause_order': '接单状态',
  'onlineOrderingSettings.order_acceptance.select.option.ordering_on': '接单中',
  'onlineOrderingSettings.order_acceptance.select.option.ordering_off': '暂停接单',
  'onlineOrderingSettings.pause_pickup_order': '到店自取',
  'onlineOrderingSettings.pause_delivery_order': '配送服务',
  'onlineOrderingSettings.pause_delivery_order.unavailable': '不可用',
  'onlineOrderingSettings.pause_order.content': '餐厅网站临时停止接单，顾客将不能下单。',
  'onlineOrderingSettings.sync_link_to_gfo': '谷歌点餐',
  'onlineOrderingSettings.sync_link_to_gfo.content':
    '开关打开后您的餐厅网站会被自动添加到对应店铺的谷歌账号，此更新通常会在24小时内生效。',
  'onlineOrderingSettings.weekday.max.three': '一天最多可以添加3个时间段。',
  'onlineOrderingSettings.blacklist_management.add.success': '添加成功',
  'onlineOrderingSettings.blacklist_management.edit.success': '编辑成功',
  'onlineOrderingSettings.blacklist_management': '黑名单管理',
  'onlineOrderingSettings.blacklist_management.content': '您可以将有问题的手机号码加入黑名单，防止其下单给您造成损失。',
  'onlineOrderingSettings.blacklist_text': '黑名单',
  'onlineOrderingSettings.blacklist.list.blocked_numbers': '已拉黑号码',
  'onlineOrderingSettings.blacklist.list.table.column.phone_number': '手机号',
  'onlineOrderingSettings.blacklist.list.table.column.reason': '原因',
  'onlineOrderingSettings.blacklist.list.table.column.created_at': '添加时间',
  'onlineOrderingSettings.blacklist.list.table.column.operator': '操作人',
  'onlineOrderingSettings.blacklist.list.table.column.action': '操作',
  'onlineOrderingSettings.blacklist.list.table.action.add': '+ 添加',
  'onlineOrderingSettings.blacklist.list.dialog.add.title': '添加新号码',
  'onlineOrderingSettings.blacklist.list.dialog.edit.title': '编辑号码',
  'onlineOrderingSettings.blacklist.list.dialog.optional': '非必选',
  'onlineOrderingSettings.blacklist.list.dialog.reason.fraudulent_activity': '银行卡盗刷',
  'onlineOrderingSettings.blacklist.list.dialog.reason.high_risk_of_no_show': '多次恶意下单未取',
  'onlineOrderingSettings.blacklist.list.dialog.reason.other': '其他',
  'onlineOrderingSettings.blacklist.list.table.delete.confirm.title': '删除确认',
  'onlineOrderingSettings.blacklist.list.table.delete.confirm.content': '确定要删除这条黑名单记录吗？',
  'onlineOrderingSettings.blacklist.list.dialog.input.placeholder': '例如',
  'onlineOrderingSettings.blacklist.list.dialog.phone.invalid': '请输入10位手机号码',

  'onlineOrderingSettings.self_delivery.enable_self_delivery': '开启餐厅网站的配送模式。设置自配送和指定司机，请前往',
  'onlineOrderingSettings.self_delivery.status': '状态',
  'onlineOrderingSettings.self_delivery.fee': '递送费设置，请前往',
  'onlineOrderingSettings.self_delivery.delivery_area': '配送范围',
  'onlineOrderingSettings.self_delivery.radius': '配送半径',
  'onlineOrderingSettings.self_delivery.miles': '英里',
  'onlineOrderingSettings.self_delivery.delivery_time': '预估配送时间',
  'onlineOrderingSettings.self_delivery.delivery_time.mins': '分钟',
  'onlineOrderingSettings.self_delivery.delivery_instructions': '配送说明',
  'onlineOrderingSettings.self_delivery.enable_instructions':
    '启用向客人提供送货订单的说明。此消息将显示在订单确认页面和数字收据中，而不是厨房小票中。',
  'onlineOrderingSettings.self_delivery.assign_driver': '指定司机',
  'onlineOrderingSettings.self_delivery.assign_driver_content': '手动完成订单时，点击“完成”后会弹出窗口分配司机。',

  'onlineOrderingSettings.section.fee.policy': '递送费收费规则',
  'onlineOrderingSettings.section.fee.fixed': '固定递送费',
  'onlineOrderingSettings.section.fee.tiered.tip': '(请先设置好最大配送范围)',
  'onlineOrderingSettings.section.fee.tiered': '分段收递送费',
  'onlineOrderingSettings.section.fee.tiered.table.starting_mile': '起始距离',
  'onlineOrderingSettings.section.fee.tiered.table.end_mile': '结束距离',
  'onlineOrderingSettings.section.fee.amount': '金额',
  'onlineOrderingSettings.section.fee.amount.required': '金额必填',
  'onlineOrderingSettings.section.fee.mile_gt.required': '起始距离必填',
  'onlineOrderingSettings.section.fee.mile_le.required': '结束距离必填',
  'onlineOrderingSettings.section.fee.exclusive': '不包含',
  'onlineOrderingSettings.section.fee.inclusive': '包含',
  'onlineOrderingSettings.section.fee.add.policy': '添加',

  'onlineOrderingSettings.section.endmile.valid': '结束距离必须大于起始距离',
  'onlineOrderingSettings.section.fee.max_mile_le': '设置的最大结束距离必须大于等于',
  'onlineOrderingSettings.section.tired.remove': '删除',
};
